import Div from '@ui/layout/Div'
import { useTranslation } from 'react-i18next'
import Commands from '@scene/window/permission/__partials/Commands'
import UserRolesList from '@scene/window/permission/__partials/UserRolesList'

const ManagePermissions = () => {
  const [t] = useTranslation('permissions')

  return (
    <Div cssClass='permissions-manager'>
      <h2 className='zone-title'>{t('titles.manage_authorizations')}</h2>
      <Commands />
      <UserRolesList />
    </Div>
  )
}

export default ManagePermissions